export enum HandsFreeInputType {
  ASSET_SEARCH,
  USER_SEARCH,
  MAINTENANCE_TASK_SEARCH,
  RESERVATION_SEARCH,
  RAW_INPUT
}
